import { render, staticRenderFns } from "./disCountList.vue?vue&type=template&id=9f206658&"
import script from "./disCountList.vue?vue&type=script&lang=ts&"
export * from "./disCountList.vue?vue&type=script&lang=ts&"
import style0 from "./disCountList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports